import {
  Controller,
  Id,
  RequestClosingSituation,
  RequestClosingStatus,
  RequestTicketStatusSync,
  RequestUserData
} from 'src/types'

import {
  ResponseDataRequests,
  ResponseDataRequestsItem
} from '../requests/types'

export enum ClosingsActionTypes {
  GET_CLOSINGS = '@closings/GET_CLOSINGS',
  GET_CLOSINGS_FAILURE = '@closings/GET_CLOSINGS_FAILURE',
  GET_CLOSINGS_SUCCESS = '@closings/GET_CLOSINGS_SUCCESS',
  SET_CLOSING_STATUS = '@closings/SET_CLOSING_STATUS',
  SET_CLOSING_STATUS_FAILURE = '@closings/SET_CLOSING_STATUS_FAILURE',
  SET_CLOSING_STATUS_SUCCESS = '@closings/SET_CLOSING_STATUS_SUCCESS'
}

interface RequestClosing {
  request_closing_id: Id
  request_user_data: RequestUserData
  situation: RequestClosingSituation
  status: RequestClosingStatus
}

interface ResponseDataClosingsItem
  extends Omit<ResponseDataRequestsItem, 'status'> {
  controllers: Controller[]
  request_closings: RequestClosing[]
  status: RequestClosingStatus
  sync_status: RequestTicketStatusSync
}

export interface ResponseDataClosings
  extends Omit<ResponseDataRequests, 'requests'> {
  requests: ResponseDataClosingsItem[]
}

export interface ClosingsState {
  readonly error: string
  readonly filterStatus: string[]
  readonly list: ResponseDataClosingsItem[]
  readonly loading: boolean
  readonly setStatusError: string
  readonly setStatusLoading: boolean
  readonly setStatusSuccess: string
  readonly total_results: number
}
